module.exports = __webpack_public_path__ + "img/logo-meetendo.3e47188e.svg";